import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import Icon, { GLYPHS } from '../icon';

const PendingConnectionModal = ({ text }) => (
  <Modal
    className="pending-connection-modal"
    close={null}
    showHeader={false}
  >
    <div className="modal-container">
      <div className="modal-container__body">
        <Icon glyph={GLYPHS.hourglass} size="medium" />
        <h1>Pending connection</h1>
        <span>{text}</span>
      </div>
    </div>
  </Modal>
);

PendingConnectionModal.propTypes = {
  text: PropTypes.string.isRequired,
};

export default PendingConnectionModal;
